module.exports = __webpack_public_path__ + "files/e3338f9596a9a5066963226a7ce098b0.png";